<template>
  <div class="apaas-preview-video">
    <div ref="video" @click.stop></div>
  </div>
</template>

<script>
  import "xgplayer";
  import Player  from "xgplayer";

  export default {
    name: "ApaasVedioPreview",
    props: {
      href: {
        type: String,
        default: ""
      },
    },
    mounted() {
      this.initVideo();
    },
    methods: {
      initVideo() {
        let player = new Player({
          el: this.$refs.video,
          url: this.href,
          playsinline: true,
          cors: true,
          whitelist: [""],
          width: null,
          height: null,
          fluid: false,
          videoInit: true,
          playbackRate: [0.5, 0.75, 1, 1.5, 2],
          rotate: {
            clockwise: true,
            innerRotate: true,
          },
          volume: 0.4,
          closeVideoClick: true,
          "x5-video-player-type": "h5",
          "x5-video-player-fullscreen": "true",
          "x5-video-orientation": "landscape",
        });

      },
    },
  };
</script>

<style lang="less">
  .apaas-preview-video {
    width: 100%;
    height: 100%;
  }

  .xgplayer-rotate {
    margin-right: 20px;
  }
</style>
